import { Component } from '@angular/core';
import { SharedModule } from '../../../../app/shared/shared.module';

declare var jQuery:any;

@Component({
  standalone: true,
  imports: [ SharedModule ],
  selector: 'blankLayout',
  templateUrl: 'blankLayout.template.html'
})
export class BlankLayoutComponent {

  ngAfterViewInit() {
    jQuery('body').addClass('gray-bg');
  }

  ngOnDestroy() {
    jQuery('body').removeClass('gray-bg');
  }
}
